"use client";

import { useAuthContext } from "@/context/auth-context";

export const useIsApiReady = () => {
  const { token } = useAuthContext();
  return !!token;
};
